import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorWhite = createSvgIcon(
  <circle cx="10" cy="10" fill="#fff" r="9.5" stroke="#838383" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorWhite',
);
